module.exports = __webpack_public_path__ + "img/CNN logo.f7e11544.jpg";